/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        // Show sub-menu on hover
        $(".nav-primary .menu-item-has-children").hover(function () {
            $(this).find('.sub-menu').stop().slideDown('fast');
         }, function () {
             $(this).find('.sub-menu').stop().slideUp('slow');
         });

        // Extend sub-menu with more than 3 items

        function expandSubMenu(sub_menus){
            sub_menus.each(function(){
                var sub_menu = $(this).children();
                if(sub_menu.length > 3){
                    sub_menu.parent().css('width', '530px');
                    sub_menu.parent().css('margin-left', '-265px');
                    sub_menu.parent().find('li').css('float', 'left');
                }
            });
        }
        if ( $(window).width() > 991 ) {
            var national_sub_menus =  $(".nav-primary ul.sub-menu");
            var local_sub_menus = $("#menu-local-navigation ul.sub-menu");
            expandSubMenu(national_sub_menus);
            expandSubMenu(local_sub_menus);
        }

        // Tablet only menu
        function showHideTablet(){
          $('.hamburger').toggleClass('active');
          $('.tablet-menu .menu-corporate-menu-container').toggleClass('active');
          $('.dimmer').toggleClass('active');
        }

        $('.tablet-only .hamburger').click(function(){
          showHideTablet();
        });

        $('.dimmer').click(function(){
          showHideTablet();
        });

        // Add social media under tablet and mobile navigation
        var socialIcons = '<ul class="social-icons">' +
                          '<li><a href="https://www.facebook.com/crockadoodleinc target="_blank" title="Follow us on Facebook" rel="noopener">' +
                          '<i class="fa fa-facebook" aria-hidden="true"></i>' +
                          '</a></li>' +
                          '<li><a href="https://twitter.com/crockadoodle" target="_blank" title="Follow us on Twitter" rel="noopener">' +
                          '<i class="fa fa-twitter" aria-hidden="true"></i>' +
                          '</a></li>' +
                          '<li><a href="https://www.youtube.com/user/CrockADoodlePottery" target="_blank" title="Follow us on YouTube" rel="noopener">' +
                          '<i class="fa fa-youtube-play" aria-hidden="true"></i>' +
                          '</a></li>' +
                          '<li><a href="https://www.pinterest.ca/crockadoodle" target="_blank" title="Follow us on Pinterest" rel="noopener">' +
                          '<i class="fa fa-pinterest" aria-hidden="true"></i>' +
                          '</a></li>' +
                          '<li><a href="https://www.instagram.com/crockadoodleinc/" target="_blank" title="Follow us on Instagram" rel="noopener">' +
                          '<i class="fa fa-instagram" aria-hidden="true"></i>' +
                          '</a></li>' +
                          '</ul>';
        $('.tablet-menu .menu-corporate-menu-container, .mobile-only .menu-corporate-menu-container').append('<hr>');
        $('.tablet-menu .menu-corporate-menu-container, .mobile-only .menu-corporate-menu-container').append(socialIcons);

        /*
         * Mobile only menu configuration
         */

        // Show sub-menu on hover on local tempalte
        $(".local-nav-home .menu-local-navigation-container .menu-item-has-children").hover(function () {
            $(this).find('.sub-menu').stop().slideDown('fast');
         }, function () {
             $(this).find('.sub-menu').stop().slideUp('slow');
         });

        function showHideMobile(){
          $('.mobile-menu .hamburger').toggleClass('active');
          $('.mobile-only .menu-corporate-menu-container').slideToggle();
        }

        $('.mobile-only .hamburger').click(function(){
          showHideMobile();
        });

        // Mobile only menu
        function showHideLocalMobile(){
          $('.mobile-local-only .hamburger').toggleClass('active');
          $('.mobile-local-only .menu-local-navigation-container').slideToggle();
          $('.wrap.container-fluid').toggleClass('mobile-sub-menu-on');
        }

        $('.mobile-local-only .hamburger').click(function(){
          showHideLocalMobile();
        });

        $('.mobile-local-only .menu-local-navigation-container').append('<hr>');
        $('.mobile-local-only .menu-local-navigation-container').append(socialIcons);

        // Show studio events as active when clicked
        var currentPath = window.location.pathname;
        if(currentPath.includes('studio-events')){
          var menu = $('#menu-local-navigation > .menu-item-type-custom a');
          eventTag = menu.filter(function(val, index){
            return index.outerHTML.includes('studio-events');
          });
          eventTag[0].style.color = '#fba919';
        }

        // Swipe carousel on mobile
        if($("#cadCarousel-mobile").length > 0){
          $("#cadCarousel-mobile").swipe({
            //Generic swipe handler for all directions
            swipe:function(event, direction, distance, duration, fingerCount, fingerData) {
              if(direction === 'left'){
                $(this).carousel('next');
              }
              if(direction === 'right'){
                $(this).carousel('prev');
              }
            }
          });
        }

        // Replace broken images by a default img
        $('img').each(function(){
            if($(this).attr('src') === ''){
              this.src = '/wp-content/themes/crockadoodle-national/assets/images/default.jpg';
            }
        });

        // Gravity form validation for Ajax
        jQuery(document).bind('gform_post_render', function(){
            // var validations = $('.validation_message');
            $('.validation_message').each(function(){
                var message = $(this).first().html();
                // var message = $(this).parent().find('input'));
                // $(this).parent().find('input').first().val("");
                $(this).parent().find('input').first().addClass('gf_red_placeholder');
                $(this).parent().find('input').first().attr('placeholder',message);
            });
            $('.validation_error').html('Error: All fields are required');
         });

         // Gravity form validation for normal submission
        //  var validations = $('.validation_message');
         $('.validation_message').each(function(){
             var message = $(this).first().html();
             // var message = $(this).parent().find('input'));
            //  $(this).parent().find('input').first().val("");
             $(this).parent().find('input').first().addClass('gf_red_placeholder');
             $(this).parent().find('input').first().attr('placeholder',message);
         });
         $('.validation_error').html('Error: All fields are required');


        // Gravity form url action on footer widget on all pages
        if($('.newsletter form').attr('action') !== undefined){
          var action_url = $('.newsletter form').attr('action').split('/');
          if(action_url.length > 2){
              action_url.splice(0, 2);
              action_url = '/' + action_url.join('/');
              $('.newsletter form').attr('action',action_url);
          }
        }

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
        if($('#vimeo-video').length > 0){
          var iframe = $('#vimeo-video');
          $('#vimeo-video').hide();
          var player = new Vimeo.Player(iframe);
          player.on('progress', function() {
              $('#vimeo-video').show();
          });
        }
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
